export default __webpack_public_path__ + "static/media/pie.c6094b89.png";